import React from 'react';
import { Row, Col, Typography, Flex } from 'antd';
import {
  useNavigate,
} from "react-router-dom";
const { Title, Paragraph } = Typography;
import ArrowButton from '../ArrowButton/ArrowButton';
import PricingPlan from '../../features/Home/PricingPlans/PricingPlan'
import { COLOURS } from '../../colours';
import useMobileCheck from '../../mobile';
import { getAppLoginUrl } from '../appUrl';
import './Pricing.css';

const Pricing = () => { 
  
  const naviagate = useNavigate();
  const { isMobile } = useMobileCheck();

  const plans = [ 
    { 
      name : "Free", 
      description: "A free forever plan that helps you get started and allows small teams to spend more time playing, and less time administering.",
      featureIntro: <>Including...<br/></>,
      features: [ 
        "up to 10 members",
        "unlimited sessions, courts and locations",
        "access to digital ped board",
        "session analytics", 
        "player statistics",
        "attendance records",
        "club messaging",
        "role based access",
        "free community support",
        "web and mobile friendly"
      ],
      backgroundColour : COLOURS.TERTIARY,
      colour: COLOURS.BLACK, 
    },
    { 
      name : "Standard", 
      description: "Level up your club with session payments, flexible pay-as-you-go options, and space for up to 25 members. Everything in Free—plus more control, less hassle.",
      featureIntro: "For a growing team, everything in Free, plus...",
      features: [ 
        "up to 25 club members",
        "take payments for sessions", 
        "pay as you go payments",
      ],
      backgroundColour : COLOURS.PRIMARY,
      colour: COLOURS.WHITE,
      price: 4.00
    },
    { 
      name : "Pro", 
      description: "Built for busy clubs that want to grow with less admin. Accept monthly membership payments, enjoy lower fees, and include up to 100 members—all with expert onboarding to make setup seamless.",
      featureIntro: "Everything in Standard, plus...",
      features: [ 
        "up to 100 club members",
        "take payments for club memberships",
        "monthly payments",
        "lower transaction charges",
        "personal onboarding",
      ],
      backgroundColour : COLOURS.TERTIARY,
      colour: COLOURS.BLACK,
      price: 8.00
    },
    { 
      name : "Extra", 
      description: "For the pro-active club that wants regular communication with their members to ensure that every session is full, and every member engaged.",
      featureIntro: "Everything in Pro, plus...",
      features: [ 
        "reminders and communication with members via WhatsApp", 
        "digital assistant for answers to all your club questions",
      ],
      backgroundColour : COLOURS.TERTIARY,
      colour: COLOURS.BLACK,
      price: 12.00
    }
  ]

  return (
    <section className="faq-wrapper"
      style={{ 
        paddingBottom: 0
      }}
      >
      <Row
        className="faq-inner"
        justify="space-between"
        align="top"
        gutter={[48, 48]}
        style={{ 
          paddingLeft: isMobile ? '10px' : '20px',
          paddingRight: isMobile ? '10px' : '20px',
          marginLeft: isMobile ? '20px' : '40px',
          marginRight: isMobile ? '20px' : '40px'
        }}
      >
        <Col xs={24} sm={6} className="faq-left">
          <Title className="faq-title">Simple.<br></br>Affordable.<br></br>Beneficial.</Title>
          <ArrowButton onClick={() => { 
            naviagate("/faq")
            document.getElementById('root').scrollTo(0, 0);
          }}>Sign Up Now</ArrowButton>
        </Col>
        <Col xs={24} sm={18} className="faq-right">
          <Flex
            style={{ 
              width: '100%'
            }}
            gap={10}
            vertical={isMobile}
            >
            { plans.map ( (plan) => { 
              return <PricingPlan { ...plan }/>
            })}
          </Flex>
          <Flex 
            style={{ 
              marginTop: 40,
            }}
            align="center"
            gap={20}
            vertical>
            <Paragraph
              style={{ 
                fontSize: '1rem'
              }}
              >
              All plans are monthly and can be changed up or down at any time. There is no obligation and we'll always be on hand to help should you need it. 
              Your members want to focus on their game, not the management of it. Why not let them?
              These figures are included plan allowances, not a ShuttleOps-wide member limit. Existing bolt-ons can add features or increase capacity, including support for 150 members.
              The ongoing Free plan is separate from the seven-day test club, which is automatically removed after seven days.
            </Paragraph>
            <a
              className="pricing-calculator-link"
              href="/calculator"
              onClick={(event) => {
                event.preventDefault();
                naviagate('/calculator');
                document.getElementById('root').scrollTo(0, 0);
              }}
            >
              Estimate your club's monthly admin and payment costs
            </a>
            <ArrowButton
              onClick={() => { 
                window.location = getAppLoginUrl();
              }}
            >Sign Up Now</ArrowButton>
          </Flex>
        </Col>

      </Row>
    </section>
  )
}


export default Pricing;
